export default __webpack_public_path__ + "static/media/1876.702668da.png";